var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sb-panel" },
    [
      _c("div", { staticClass: "sb-panel-header" }, [
        _c(
          "div",
          { staticClass: "sb-panel-title" },
          [
            _c("span", { staticClass: "sb-panel-icon" }, [_vm._t("icon")], 2),
            _vm._v(" "),
            _vm._t("title"),
            _vm._v(" "),
            _vm.refreshedAt
              ? _c("span", { staticClass: "sb-panel-refresh" }, [
                  _vm._v(
                    "\n        · Last refreshed " +
                      _vm._s(_vm.refreshedAt) +
                      "\n      "
                  )
                ])
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _c("div", { staticClass: "sb-panel-actions" }, [
          _c(
            "button",
            {
              staticClass: "sb-icon-btn",
              attrs: { title: "Pin" },
              on: {
                click: function($event) {
                  return _vm.$emit("pin")
                }
              }
            },
            [
              _c("span", { staticClass: "material-icons-outlined" }, [
                _vm._v("push_pin")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sb-icon-btn",
              attrs: { title: "Help" },
              on: {
                click: function($event) {
                  return _vm.$emit("help")
                }
              }
            },
            [
              _c("span", { staticClass: "material-icons-outlined" }, [
                _vm._v("help_outline")
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sb-icon-btn",
              attrs: { title: _vm.collapsed ? "Expand" : "Collapse" },
              on: {
                click: function($event) {
                  _vm.collapsed = !_vm.collapsed
                }
              }
            },
            [
              _c("span", { staticClass: "material-icons-outlined" }, [
                _vm._v(
                  _vm._s(
                    _vm.collapsed ? "keyboard_arrow_down" : "keyboard_arrow_up"
                  )
                )
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "sb-collapse" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.collapsed,
                expression: "!collapsed"
              }
            ],
            staticClass: "sb-panel-body"
          },
          [_vm._t("default")],
          2
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }